@if (show) {
<mat-form-field>
    <mat-label>Customer</mat-label>
    <input #input type="text" matInput [formControl]="customer" [matAutocomplete]="auto"
        (input)="filter()" (focus)="filter()">
    <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayWithFunc">
        @for (customer of filteredCustomers; track customer) {
        <mat-option [value]="customer">({{customer.id | number:'5.0-0' | removeCommas}}) {{customer.first_name}} {{customer.last_name}}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
}